import {forEach} from "../helpers";
import axios from "axios";
import qs from "qs";

export class AutoLoading {

  constructor($wrapper, type) {
    this.$wrapper = $wrapper;
    this.type = type;
    this.$container = $wrapper.querySelector(`.js-auto-loading-${type}`);
  }

  init() {
    this.buttons = this.$wrapper.querySelectorAll(`.js-auto-loading-${this.type}-btn`);
    forEach(this.buttons, button => this.listener(button));
  }

  listener(button) {
    button.addEventListener('click', () => {
      if (button.classList.contains('is-active')) return;
      this.getData(button);
    });
  }

  actions() {}

  getData(button) {
    const json = JSON.parse(button.getAttribute('data-auto-loading-params'));
    const url = button.getAttribute('data-auto-loading-url');
    const params = {};
    params.PARAMS = json;

    this.loading(true);

    axios.get(url, {
      params,
      paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'brackets'})
      },
    })
      .then(response => this.actions(button, response.data.data.html))
      .catch(error => console.log(error));
  }

  loading(state) {
    this.$container.classList[state === true ? 'add' : 'remove']('is-loading');
  }

}
